import queryString from 'query-string'

export const urlListView = (slug = '') => `/lists/${slug}`

export const urlListProductContent = (listID, productAvailabilityId) =>
  `/list/${listID}/items/${productAvailabilityId}/content`

export const urlListSearch = (searchTerm = '') => {
  const query = queryString.stringify({ term: searchTerm })

  return `/lists?${query}`
}
